import { render, staticRenderFns } from "./discri.vue?vue&type=template&id=d3293492"
import script from "./discri.vue?vue&type=script&lang=js"
export * from "./discri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports